import(/* webpackMode: "eager" */ "/vercel/path0/src/app/store-policy/page.js");
